import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import CustomButton from "../../../components/UI/customButton/customButton";
import { toast } from "react-toastify";
import { Get, Post } from "../../../apis/api";
import LoadingFix from "../../../components/loading-fix/loading-fix";
import moment from "moment-jalaali";
import mohr from "../../../assets/img/mohr.jpg";
import emza from "../../../assets/img/emza.jpg";
import html2pdf from 'html2pdf.js';
import { useNavigate, useParams } from "react-router-dom";
import CustomCheckBox from "../../../components/UI/customCheckBox/customCheckBox";
import formLogo from "../../../assets/img/form-logo.png"
import wave from "../../../assets/img/wave.png"
import CustomRadio from "../../../components/UI/customRadio/customRadio";
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css';
import { useSelector } from "react-redux";
import MultiUploader from "../../../components/multiUpload/multiUpload";
import clsx from 'clsx';
import { isFileImage } from '../../../utils/new'
import Loading from '../../../components/Loading';
import { useQuery } from 'react-query';

// defaultEmails = [{title:string}]
// defaultLetterNumber = string
//mode = 'page' | 'pdf'

const FormNumberTwo = ({ activeStep, defaultEmails, defaultLetterNumber, defaultId,

  // hideComponent, onPdf, buildPdf,
  mode = 'page',

  atNumber = '',
  setCreatePDFasync, createPDFasync }) => {
  const { t } = useTranslation();
  // const [data, setData] = useState(false);
  // const [emails, setEmails] = useState([]);
  const [visaType, setVisaType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [emailList, setEmailList] = useState(null);
  const [ccList, setCcList] = useState([]);
  const [createPdf, setCreatePdf] = useState(false);
  const [form, setForm] = useState(false);
  const [emailBody, setEmailBody] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [editorData, setEditorData] = useState({});
  const [wordFile, setWordFile] = useState(undefined)

  const contentRef = useRef(null);
  const contentRef2 = useRef(null);
  const contentRef3 = useRef(null);
  const params = useParams()
  const navigate = useNavigate()
  const cityList = useSelector((state) => state.setting.city)
  const countryList = useSelector((state) => state.setting.country)

  const isPDFMode = mode == 'pdf'


  // useEffect(() => {
  //   handleEmailsList()
  // }, [])
  const editor = useRef();

  const getSunEditorInstance = (sunEditor) => {
    editor.current = sunEditor;
  };

  const handleForm = ({ name, value }) => {
    setForm((prevState) => ({ ...prevState, [name]: value }))
  }

  const { data: emailsData } = useQuery({
    queryFn: () => Get(`basic-information/email?page=${1}&per_page=${100}`),
    queryKey: ['Get-Emails']
  })

  const emails = emailsData?.details?.data


  const handleEmails = (e) => {
    console.log(e)
    setEmailList({ id: e.id, name: e.name });
  };

  const handleCc = (e) => {
    const newList = [...ccList];
    const find = newList.findIndex((item) => item === e);
    if (find !== -1) {
      newList.splice(find, 1);
    } else {
      newList.push(e);
    }

    setCcList(newList);
  };


  const convertToPdf = async () => {
    setCreatePdf(true)

    // setLoading(true)

    // if (mode == 'pdf')
    //   await refetch()

    try {


      const content = contentRef.current;
      const content2 = contentRef2.current;
      const content3 = contentRef3.current;

      // ذخیره استایل‌های اصلی
      const originalPadding = content?.style?.padding;
      const originalMargin = content?.style?.margin;
      const originalFontSize = content.style.fontSize;
      const originalMarginLeft = content2.style.marginLeft;
      const originalMarginB = content3.style.marginBottom;

      // تغییر استایل
      content.style.padding = "0";
      content.style.margin = "40px";
      content2.style.marginLeft = "0px";
      // content3.style.marginBottom = "320px";
      content3.style.marginBottom = "4px";
      content.style.fontSize = "12px";

      const options = {
        filename: 'my-document.pdf',
        margin: 0,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: {
          unit: 'in',
          format: 'letter',
          orientation: 'portrait',
        },
      };

      // تولید PDF
      const pdfBlob = await html2pdf().set(options).from(content).toPdf().output('blob');

      // بازگردانی استایل‌ها به حالت اولیه
      content.style.padding = originalPadding;
      content.style.margin = originalMargin;
      content.style.fontSize = originalFontSize;
      content2.style.marginLeft = originalMarginLeft;
      content3.style.marginBottom = originalMarginB;
      setCreatePdf(false)
      // setLoading(false)
      return pdfBlob; // Return the Blob
    } catch (error) {
      return 'Zart'
    }
  };


  const handleExtractPDF = async () => {

    if (!data)
      await refetch()
    await (new Promise((res) => setTimeout(() => res("p2"), 200)))
    return convertToPdf()
  }


  useEffect(() => {
    if (setCreatePDFasync && !createPDFasync) {
      setCreatePDFasync(() => handleExtractPDF)
    }
  }, [handleExtractPDF])


  const { isLoading, isError, data: visaAllData, refetch } = useQuery({
    queryFn: ({ queryKey }) => {
      setLoading(true)
      return Get(`admin/visas/show/${queryKey[1]}`)
    },
    queryKey: ['GetVisa', defaultId ?? params?.id],
    onSuccess: (res) => {
      setVisaType(res?.details?.data?.visa?.visa_type);
      // if (buildPdf) {
      //   setTimeout(() => convertToPdf().then(pdf => onPdf(pdf)), 250)
      // }
    },
    onError: (error) => {
      toast.error(error.message || error.msg || error?.data?.message);
    },
    onSettled: () => {
      setLoading(false)
    },
    retry: 0,
    staleTime: 0,
    cacheTime: 0,
    enabled: mode == 'pdf' ? false : true
  })


  const data = visaAllData?.details?.data
  const nationalityArray = visaAllData?.details?.nationality


  useEffect(() => {
    if (data)
      setVisaType(data?.visa?.visa_type);
  }, [data])

  // const handleList = () => {
  //   setLoading(true);

  //   Get(`admin/visas/show/${params?.id || localStorage.getItem("visaId")}`)
  //     .then((res) => {
  //       setData(res?.details?.data);
  //       setVisaType(res?.details?.data?.visa?.visa_type);
  //     })
  //     .catch((error) => {
  //       toast.error(error.message || error.msg || error?.data?.message);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  //   // Post(`notification/read/${params?.id || localStorage.getItem("visaId")}`)
  //   //   .then((res) => {

  //   //   })
  //   //   .catch((error) => {
  //   //   })
  //   //   .finally(() => {
  //   //     setLoading(false);
  //   //   });
  // };



  const handleSubmit = async () => {
    setLoading(true);
    if (form["letter_number"] && emailBody) {

      // if (!wordFile)
      //   return toast.error(t('WordFileIsNotSelected'))
      const pdfBlob = await convertToPdf();


      const formData = new FormData();
      formData.append("form", "atbae_from");
      formData.append("subject", text.subject[visaType]);
      formData.append("emails[0]", emailList.id);
      console.log(ccList)
      Object.keys(ccList).forEach(key => {
        formData.append(`cc[${key}]`, ccList[key]);
      });
      const toSendAtts = [...attachments, ...(wordFile ? [wordFile] : [])]
      toSendAtts?.forEach((item, index) => {
        formData.append(`attachments[${index}][file]`, item);
        formData.append(`attachments[${index}][title]`, "attachment" + "-" + [index]);
      });


      formData.append("atbae_file", pdfBlob, 'my-document.pdf');
      formData.append("letter_number", form["letter_number"])
      formData.append("email_body", emailBody)

      Post(`admin/visas/send-atbae/${params?.id || localStorage.getItem("visaId")}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((res) => {
          toast.success(res.msg);
          navigate("/")
        })
        .catch((error) => {
          toast.error(error.data.message || error.data.msg);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      if (emailBody) {
        toast.error("شماره نامه را وارد کنید.")

      } else {
        toast.error("خلاصه متن ایمیل را وارد کنید.")

      }
    }

  };
  const formatText = (text) => {
    return text.split('.').map((sentence, index) => (
      <span key={index}>
        {sentence.trim()}.<br />
      </span>
    ));
  };

  const flagCountryName = data?.ship?.country?.fa_name

  const text = {
    "subject": {
      "Extension for 6 months": "درخواست تمدید پروانه اقامت",
      "Final exit": "درخواست صدور روادید 15 روزه جهت خروج از کشور",
      "Extension for 3 months": "درخواست تمدید پروانه اقامت",
      "Obtaining for 6 months": "درخواست اخذ پروانه اقامت ",
      "Obtaining for 3 months": "درخواست اخذ پروانه اقامت ",
      "72-hour_accession_departure": "درخواست صدور روادید 72 ساعته جهت خروج کشور ",
      "72-hour_accession_entry": "درخواست صدور روادید 72 ساعته جهت الحاق به شناور ",
    },
    "emailBody": {
      "Extension for 6 months": ` اقدام کند. خواهشمند است نتیجه را به این شرکت منعکس نمایید. در پیوست مدارک ایشان تقدیم حضورتان گردیده است ${data?.ship?.name} به استحضار می‌رساند این شرکت در نظر دارد برای صدور تمدید پروانه اقامت شناور `,
      "Obtaining for 6 months": ` اقدام کند. خواهشمند است نتیجه را به این شرکت منعکس نمایید. در پیوست مدارک ایشان تقدیم حضورتان گردیده است ${data?.ship?.name} به استحضار می‌رساند این شرکت در نظر دارد برای اخذ پروانه اقامت خروجی شناور `,
      "Extension for 3 months": ` اقدام کند. خواهشمند است نتیجه را به این شرکت منعکس نمایید. در پیوست مدارک ایشان تقدیم حضورتان گردیده است ${data?.ship?.name} به استحضار می‌رساند این شرکت در نظر دارد برای صدور تمدید پروانه اقامت شناور `,
      "Obtaining for 3 months": ` اقدام کند. خواهشمند است نتیجه را به این شرکت منعکس نمایید. در پیوست مدارک ایشان تقدیم حضورتان گردیده است ${data?.ship?.name} به استحضار می‌رساند این شرکت در نظر دارد برای اخذ پروانه اقامت خروجی شناور `,
      "72-hour_accession_departure": ` اقدام کند. خواهشمند است نتیجه را به این شرکت منعکس نمایید. در پیوست مدارک ایشان تقدیم حضورتان گردیده است ${data?.ship?.name} به استحضار می‌رساند این شرکت در نظر دارد برای صدور درخواست صدور روادید 72 ساعته جهت خروج کشور شناور `,
      "72-hour_accession_entry": ` اقدام کند. خواهشمند است نتیجه را به این شرکت منعکس نمایید. در پیوست مدارک ایشان تقدیم حضورتان گردیده است ${data?.ship?.name} به استحضار می‌رساند این شرکت در نظر دارد برای صدور روادید ۷۲ ساعته خروجی شناور `,
    },
    "topTitle": {
      "Extension for 6 months": {
        1: "در صدد است نسبت به درخواست تمدید پروانه اقامت دریانورد/دریانوردان مشروحه زیر جهت شناور",
        2: "به مالکیت",
      },
      "Obtaining for 6 months": {
        1: "در صدد است نسبت به درخواست صدور روادید 72 ساعته دریانورد/دریانوردان مشروحه زیر جهت الحاق به شناور",
        2: `( با پرچم کشور  ${flagCountryName} ) به مالکیت`,
      },
      "Extension for 3 months": {
        1: "در صدد است نسبت به درخواست تمدید پروانه اقامت دریانورد/دریانوردان مشروحه زیر جهت شناور",
        2: "به مالکیت",
      },
      "Final exit": {
        1: "در صدد است نسبت به درخواست تمدید پروانه اقامت دریانورد/دریانوردان مشروحه زیر جهت شناور",
        2: "به مالکیت",
      },
      "Obtaining for 3 months": {
        1: "در صدد است نسبت به درخواست صدور روادید 72 ساعته دریانورد/دریانوردان مشروحه زیر جهت الحاق به شناور",
        2: `( با پرچم کشور  ${flagCountryName} ) به مالکیت`,
      },
      "72-hour_accession_departure": {
        1: "در صدد است نسبت به  <b> درخواست  صدور روادید 72 ساعته  </b> دریانورد مشروحه زیر بمنظور  خروج از کشور از شناور",
        2: `( با پرچم کشور  ${flagCountryName} ) به مالکیت`,
      },
      "72-hour_accession_entry": {
        1: "در صدد است نسبت به درخواست صدور روادید 72 ساعته  دریانوردان مشروحه زیر جهت الحاق به شناور ",
        2: `( با پرچم کشور  ${flagCountryName}  ) به مالکیت`,
      },
    },
  }

  // const handleFarsiDay = (e) => {
  //   const d = data?.visa_fly?.[data?.visa_fly?.length - 1]?.land_date;
  //   console.log(data?.visa_fly?.[data?.visa_fly?.length - 1]?.land_date)
  //   const options = { weekday: 'long' }; // Correctly use 'short'
  //   return new Intl.DateTimeFormat('fa-IR', options).format(d);
  // };
  const handleDayTranslation = (day) => {
    const days = {
      Sunday: 'یکشنبه',
      Monday: 'دوشنبه',
      Tuesday: 'سه‌شنبه',
      Wednesday: 'چهارشنبه',
      Thursday: 'پنج‌شنبه',
      Friday: 'جمعه',
      Saturday: 'شنبه'
    };
    return days[day] || day; // در صورت عدم وجود، روز اصلی را برمی‌گرداند
  }
  const handleCity = (id) => {
    return cityList?.find((item => {
      return (
        item.id === id
      )
    }))?.["fa_name"]
  }

  const handleText = (data) => {


    const destinationCityFaName = data?.dock?.city?.province?.fa_name

    const destinationCityEnName = data?.dock?.city?.province?.en_name

    // const destinationCityEnName = data?.dock?.city?.province?.en_name

    const dockStateWord = destinationCityFaName + " ( " + (destinationCityEnName) + " ) "

    //data.dock.city.province.fa_name
    ///data.dock.city.province.en_name
    if (visaType === "Extension for 6 months") {
      return (
        <>
          <div className={"flex justify-start w-full leading-7 indent-4 text-justify"}>
            <>{`خواهشمند است نسبت به  ${data?.visa?.fa_name} با خروج و مراجعت مکرر سه ماهه نامبرده/نامبردگان از تاریخ اتمام پروانه اقامت 6 ماهه`}</>
            <>{`  از طریق مدیریت پلیس مهاجرت و گذرنامه ناجا استان  ${data?.dock?.city?.province?.fa_name} `}</>
            {/* <>{` از طریق مدیریت پلیس مهاجرت و گذرنامه ناجا  ${handleCity(data?.visa_fly?.[data?.visa_fly?.length - 1]?.destination?.["city_id"]) + " ( " + (data?.visa_fly?.[data?.visa_fly?.length - 1]?.destination?.code) + " ) "} `}</> */}
            <>{`اوامر مقتضی صادر فرمایید.`}</>
          </div>
          <span className={"leading-7 indent-4 text-justify"}>
            {formatText("ضمنا یادآوری می شود از آنجائیکه نمایندگی شناور ذکر شده به عهده این شرکت می باشد این مدیریت نیز در تمامی موارد به دریانورد/دریانوردان یادشده در برابر اتحادیه و پلیس مهاجرت و گذرنامه ناجا پاسخگو می باشد")}
          </span>
        </>
      )
    } else if (visaType === "72-hour_accession_departure") {
      return (
        <>
          {/* <span className={"leading-7 indent-4 text-justify"}>
            {formatText(`نامبرده روز 
            ${handleDayTranslation(moment(data?.visa_fly?.[data?.visa_fly?.length - 1]?.land_date).format('dddd'))}
             مورخ ${moment(data?.visa_fly?.[data?.visa_fly?.length - 1]?.land_date).format("jDD / jMM / jYYYY")}
              از طریق مرز دریایي با شناور یاد شده از مبدأ 
              ${data?.dock?.city?.fa_name}  
              وارد بندر 
              ${(data?.dock?.name) + " ( " + (data?.dock?.code) + " ) "} 
              در موعد مقرر كشور را ترك خواهند نمود . خواهشمند است در خصوص صدور روادید 72 ساعته (در سیمن بوک ) جهت الحاق به شناور یادشده از طریق مدیریت پلیس مهاجرت و گذرنامه استان  شده و در اسکله تجاری 
              ${(data?.visa_fly?.[data?.visa_fly?.length - 1]?.origin?.fa_name) + " ( " + (data?.visa_fly?.[data?.visa_fly?.length - 1]?.origin?.code) + " ) "}
               مستقر میگرددو شناور پس از اتمام تخلیه و بارگیري در موعد مقرر كشور را ترك خواهد نمود.با توجه به اینكه دریانورد یاد شده در مورخ فوق الذکر به دلیل شرایط اضطراري از شناور پیاده و قصد مراجعت به موطن خود را دارد، لذا خواهشمند است در خصوص صدور روادید 72 ساعته جهت خروج ازكشور (مرزهوائي ، فرودگاه 
               ${(data?.visa_fly?.[data?.visa_fly?.length - 1]?.airline?.fa_name)})
                از طریق مدیریت پلیس مهاجرت و گذرنامه  استان 
                ${handleCity(data?.visa_fly?.[data?.visa_fly?.length - 1]?.destination?.["city_id"]) + " ( " + (data?.visa_fly?.[data?.visa_fly?.length - 1]?.destination?.code) + " ) "} 
                از تاریخ صدرالاشاره اوامر مقتضي صادر فرمایند.ضمنا یادآور می شود از آنجائیکه نمایندگی شناور ذکر شده به عهده این شرکت می باشد این مدیریت نیز در تمامی موارد مربوط به دریانورد یاد شده در برابر اتحادیه و پلیس مهاجرت و گذرنامه ناجا پاسخگو می باشد.`)}
          </span> */}

          <p className={"leading-7 indent-4 text-justify "} dangerouslySetInnerHTML={{
            __html: clsx(
              `نامبرده روز `
              ,`<b>${!!data?.exit_date ? handleDayTranslation(moment(data?.exit_date).format('dddd')) : '-'}</b>`,
              ` مورخ <b>${!!data?.exit_date  ? moment(data?.exit_date).format("jDD / jMM / jYYYY") : '-'}</b>`,
              ' از طریق مرز دریایي با شناور یاد شده از مبدأ ',
              `<b>${data?.destination_dock?.city?.province?.country?.[0]?.fa_name} ( اسکله ${data?.destination_dock?.name}  ${data?.destination_dock?.code})، </b>`,
              'وارد بندر ',
              `<b>${(data?.dock?.city?.fa_name)}</b> شده`,
              'و در اسکله تجاری ',
              `<b>${data?.dock?.name ?? '--'} (${data?.dock?.code}) </b>`,
              ' مستقر میگردد و شناور پس از اتمام تخليه و بارگيري در موعد مقرر كشور را ترك خواهد نمود. ',
              '<br class="mt-2" /><div class="mt-2"/>',
              ' با توجه به اينكه دريانورد ياد شده در مورخ فوق الذکر به دليل شرايط اضطراري از شناور پياده و قصد مراجعت به موطن خود را دارد، لذا خواهشمند است در خصوص',
              '<b>صدور رواديد 72 ساعته جهت خروج از كشور </b>',
              `(مرزهوائي ، فرودگاه <b>${data?.exit_airport?.fa_name ?? '-'} (${data?.exit_airport?.code ?? '-'}) </b> ) `,
              `  واز طريق  <b> مديريت  پليس مهاجرت و گذرنامه استان ${data?.exit_airport?.city?.province?.fa_name ?? '-'}</b>`,
              ' از تاریخ صدرالاشاره اوامر مقتضي صادر فرمايند.',
              '<br/>',
              '<p class="indent-4 text-justify mt-2"> ضمناً ياد آور مي شود از آنجائيكه نمايندگي شناور ذكر شده به عهده اين شركت مي باشد این مديريت نيز در تمامي موارد مربوط به دريانورد ياد شده در برابر اتحاديه و پليس مهاجرت و گذرنامه ناجا پاسخگو مي باشد.</p>',
              // '<br/></br/>',
              // ' خواهشمند است در خصوص صدور روادید 72 ساعته (در سیمن بوک ) جهت الحاق به شناور یادشده از طریق مدیریت پلیس مهاجرت و گذرنامه استان  شده و در اسکله تجاری ',
              // (data?.visa_fly?.[data?.visa_fly?.length - 1]?.origin?.fa_name) + " ( " + (data?.visa_fly?.[data?.visa_fly?.length - 1]?.origin?.code) + " ) ",
              // ' مستقر میگرددو شناور پس از اتمام تخلیه و بارگیري در موعد مقرر كشور را ترك خواهد نمود.با توجه به اینكه دریانورد یاد شده در مورخ فوق الذکر به دلیل شرایط اضطراري از شناور پیاده و قصد مراجعت به موطن خود را دارد، لذا خواهشمند است در خصوص صدور روادید 72 ساعته جهت خروج ازكشور (مرزهوائي ، فرودگاه ',
              //   (data?.visa_fly?.[data?.visa_fly?.length - 1]?.airline?.fa_name),
              // '  از طریق مدیریت پلیس مهاجرت و گذرنامه  استان ',
              // handleCity(data?.visa_fly?.[data?.visa_fly?.length - 1]?.destination?.["city_id"]) + " ( " + (data?.visa_fly?.[data?.visa_fly?.length - 1]?.destination?.code) + " ) ",
              // ' از تاریخ صدرالاشاره اوامر مقتضي صادر فرمایند.ضمنا یادآور می شود از آنجائیکه نمایندگی شناور ذکر شده به عهده این شرکت می باشد این مدیریت نیز در تمامی موارد مربوط به دریانورد یاد شده در برابر اتحادیه و پلیس مهاجرت و گذرنامه ناجا پاسخگو می باشد.'
            )
          }} >
          </p>
        </>
      )
    } else if (visaType === "Final exit") {
      return (
        <>
          <span className="leading-7 indent-4 text-justify">
            با توجه به اینکه
            {data?.crews?.map((item, index) => {
              const fullName = `${item?.crew?.name} ${item?.crew?.last_name}`;
              const date = moment(item?.crew?.passport_expire).format('jDD / jMM / jYYYY');
              return (
                <span key={index}>
                  {" " + fullName + " "} تا تاریخ {date}
                  {index < data.crews.length - 1 && ' و '} {/* Adding a comma except for the last item */}
                </span>
              );
            })}
            دارای روادید بوده‌اند.
            {/* <br /> */}
            خواهشمند است ضمن ابطال روادید و دریافت جرایم مربوطه در صورت عدم ممنوعیت، در خصوص صدور روادید ۱۵ روزه از طریق مدیریت پلیس مهاجرت و گذرنامه استان
            &nbsp;{data?.exit_airport?.city?.province?.fa_name} ({data?.exit_airport?.city?.province?.en_name})
            جهت خروج از کشور از طریق مرز هوایی فرودگاه
            &nbsp;<b className='font-black'>{data?.exit_airport?.fa_name ?? '-'} ({data?.exit_airport?.code ?? '-'})</b> &nbsp;
            اوامر مقتضی صادر فرمایند. ضمناً یادآور می‌شود از آنجائیکه نمایندگی شناور ذکر شده به عهده این شرکت می‌باشد، این مدیریت نیز در تمامی موارد مربوط به دریانوردان یاد شده در برابر اتحادیه و پلیس مهاجرت و گذرنامه ناجا پاسخگو می‌باشد.
          </span>
        </>
      )
    } else if (visaType === "72-hour_accession_entry") {
      return (
        <>
          <span className={"leading-7 indent-4 text-justify"}>
            {formatText(` نامبردگان روز ${handleDayTranslation(moment(data?.visa_fly?.[data?.visa_fly?.length - 1]?.land_date).format('dddd'))} مورخ ${moment(data?.visa_fly?.[data?.visa_fly?.length - 1]?.land_date).format("jDD / jMM / jYYYY")} از طریق مرز هوایي با پرواز ${(data?.visa_fly?.[data?.visa_fly?.length - 1]?.airline?.fa_name)} شماره ${data?.visa_fly?.[data?.visa_fly?.length - 1]?.fly_no} ساعت ${moment(data?.visa_fly?.[data?.visa_fly?.length - 1]?.land_date).format("ss : mm : HH")} از مبدأ
            ${(data?.visa_fly?.[data?.visa_fly?.length - 1]?.origin?.fa_name) + " ( " + (data?.visa_fly?.[data?.visa_fly?.length - 1]?.origin?.code) + " ) "} 
            وارد فرودگاه 
            ${(data?.visa_fly?.[data?.visa_fly?.length - 1]?.destination?.fa_name) + " ( " + (data?.visa_fly?.[data?.visa_fly?.length - 1]?.destination?.code) + " ) "} 
            شده و پس از الحاق به شناور یاد شده مستقر در اسکله تجاری ${(data?.dock?.name) + " ( " + (data?.dock?.code) + " ) "} در موعد مقرر كشور را ترك خواهند نمود. خواهشمند است در خصوص صدور روادید 72 ساعته (در سیمن بوک) جهت الحاق به شناور یادشده از طریق مدیریت پلیس مهاجرت و گذرنامه استان ${dockStateWord} از تاریخ ورود به کشور اوامر مقتضی صادر فرمایند. ضمنا یادآور می‌شود از آنجائیکه نمایندگی شناور ذکر شده به عهده این شرکت می‌باشد این مدیریت نیز در تمامی موارد مربوط به دریانورد یاد شده در برابر اتحادیه و پلیس مهاجرت و گذرنامه ناجا پاسخگو می‌باشد`)}
          </span>
        </>
      )
    } else if (visaType === "Obtaining for 6 months") {

      if (!data) return ''

      const lastFly = data?.visa_fly?.findLast(i => i)

      return (
        <>

          <span className={"leading-7 indent-4 text-justify"} dangerouslySetInnerHTML={{
            __html: clsx(`   نامبرده / نامبردگان روز 
            ${handleDayTranslation(moment(lastFly?.land_date).format('dddd'))}
             مورخ ${moment(lastFly?.land_date).format("jDD / jMM / jYYYY")} 
             از طریق مرز هوایی با پرواز
             <b class='font-sans'>${lastFly?.airline?.fa_name ?? '-'}</b>
             شماره
            <b class='font-sans'>${lastFly?.fly_no ?? '-'}</b>
            ساعت 
           <b class='font-sans'> ${moment(lastFly?.land_date).format('hh:mm')}</b>
             از مبدا 
             ${(lastFly?.origin?.fa_name) + " ( " + (lastFly?.origin?.code) + " ) "} 
             وارد فرودگاه 
             ${(lastFly?.destination?.fa_name) + " ( " + (lastFly?.destination?.code) + " ) "} 
              شده و سپس به شناور یاد شده مستقر در بندر   
            ${(data?.dock?.name) + " ( " + (data?.dock?.code) + " ) "}  
            ملحق می گردند .
            <br class='mt-4'/>
             خواهشمند است در خصوص صدور مجوز 72 ساعته و پروانه اقامت 6 ماهه (نوبت اول) با خروج و مراجعت مكرر سه ماهه نامبرده / نامبردگان از طریق مدیریت پلیس مهاجرت و گذرنامه  
             استان ${lastFly?.destination?.city?.province?.fa_name} 
             از تاریخ ورود به کشور اوامر مقتضی صادر فرمایند.
             <br />
             <br />
             ضمنا یادآور می شود از آنجائیکه نمایندگی شناور ذکر شده به عهده این شرکت می باشد این مدیریت نیز در تمامی موارد مربوط به دریانورد یاد شده در برابر اتحادیه و پلیس مهاجرت و گذرنامه ناجا پاسخگو می باشد`)
          }}>
          </span>

          {/* ///Old One */}
          {/* <span className={"leading-7 indent-4 text-justify"}>
            {formatText(`   نامبرده / نامبردگان روز 
            ${handleDayTranslation(moment(data?.visa_fly?.[data?.visa_fly?.length - 1]?.land_date).format('dddd'))}
             مورخ ${moment(data?.visa_fly?.[data?.visa_fly?.length - 1]?.land_date).format("jDD / jMM / jYYYY")} 
             از طریق مرز دریایی با شناور یاد شده از مبدأ 
             ${(data?.visa_fly?.[data?.visa_fly?.length - 1]?.origin?.fa_name) + " ( " + (data?.visa_fly?.[data?.visa_fly?.length - 1]?.origin?.code) + " ) "} 
             وارد بندر 
             ${(data?.dock?.city?.fa_name) + " ( " + (data?.dock?.city?.code) + " ) "} 
             شده و در اسكله تجاري  ${(data?.dock?.name) + " ( " + (data?.dock?.code) + " ) "}
             مستقر مي گردند .خواهشمند است در خصوص صدور مجوز 72 ساعته و پروانه اقامت 6 ماهه (نوبت اول) با خروج و مراجعت مكرر سه ماهه نامبرده / نامبردگان از طریق مدیریت پلیس مهاجرت و گذرنامه  
             ${data?.visa_fly?.[0]?.destination?.fa_name} 
             از تاریخ ورود به کشور اوامر مقتضی صادر فرمایند.ضمنا یادآور می شود از آنجائیکه نمایندگی شناور ذکر شده به عهده این شرکت می باشد این مدیریت نیز در تمامی موارد مربوط به دریانورد یاد شده در برابر اتحادیه و پلیس مهاجرت و گذرنامه ناجا پاسخگو می باشد`)}
          </span> */}
        </>
      )
    } else if (visaType === "Obtaining for 3 months") {

      if (!data) return ''

      const lastFly = data?.visa_fly?.findLast(i => i)

      return (
        <>

          <span className={"leading-7 indent-4 text-justify"} dangerouslySetInnerHTML={{
            __html: clsx(`   نامبرده / نامبردگان روز 
            ${handleDayTranslation(moment(lastFly?.land_date).format('dddd'))}
             مورخ ${moment(lastFly?.land_date).format("jDD / jMM / jYYYY")} 
             از طریق مرز هوایی با پرواز
             <b class='font-sans'>${lastFly?.airline?.en_name ?? '-'}</b>
             شماره
            <b class='font-sans'>${lastFly?.fly_no ?? '-'}</b>
            ساعت 
           <b class='font-sans'> ${moment(lastFly?.land_date).format('hh:mm')}</b>
             از مبدا 
             ${(lastFly?.origin?.fa_name) + " ( " + (lastFly?.origin?.code) + " ) "} 
             وارد فرودگاه 
             ${(lastFly?.destination?.fa_name) + " ( " + (lastFly?.destination?.code) + " ) "} 
              شده و سپس به شناور یاد شده مستقر در بندر   
            ${(data?.dock?.name) + " ( " + (data?.dock?.code) + " ) "}  
            ملحق می گردند .
            <br class='mt-4'/>
             خواهشمند است در خصوص صدور مجوز 72 ساعته و پروانه اقامت 3 ماهه (نوبت اول) با خروج و مراجعت مكرر سه ماهه نامبرده / نامبردگان از طریق مدیریت پلیس مهاجرت و گذرنامه  
             استان ${lastFly?.destination?.city?.province?.fa_name} 
             از تاریخ ورود به کشور اوامر مقتضی صادر فرمایند.
             <br />
             <br />
             ضمنا یادآور می شود از آنجائیکه نمایندگی شناور ذکر شده به عهده این شرکت می باشد این مدیریت نیز در تمامی موارد مربوط به دریانورد یاد شده در برابر اتحادیه و پلیس مهاجرت و گذرنامه ناجا پاسخگو می باشد`)
          }}>
          </span>

          {/* <span className={"leading-7 indent-4 text-justify"}>
            {formatText(`   نامبرده / نامبردگان روز ${handleDayTranslation(moment(data?.visa_fly?.[data?.visa_fly?.length - 1]?.land_date).format('dddd'))} مورخ ${moment(data?.visa_fly?.[data?.visa_fly?.length - 1]?.land_date).format("jDD / jMM / jYYYY")} از طریق مرز دریایی با شناور یاد شده از مبدأ ${(data?.visa_fly?.[data?.visa_fly?.length - 1]?.origin?.fa_name) + " ( " + (data?.visa_fly?.[data?.visa_fly?.length - 1]?.origin?.code) + " ) "} وارد بندر ${(data?.dock?.city?.fa_name) + " ( " + (data?.dock?.city?.code) + " ) "} شده و در اسكله تجاري  ${(data?.dock?.name) + " ( " + (data?.dock?.code) + " ) "}مستقر مي گردند .خواهشمند است در خصوص صدور مجوز 72 ساعته و پروانه اقامت 3 ماهه (نوبت اول) با خروج و مراجعت مكرر سه ماهه نامبرده / نامبردگان از طریق مدیریت پلیس مهاجرت و گذرنامه  ${data?.visa_fly?.[0]?.destination?.fa_name} از تاریخ ورود به کشور اوامر مقتضی صادر فرمایند.ضمنا یادآور می شود از آنجائیکه نمایندگی شناور ذکر شده به عهده این شرکت می باشد این مدیریت نیز در تمامی موارد مربوط به دریانورد یاد شده در برابر اتحادیه و پلیس مهاجرت و گذرنامه ناجا پاسخگو می باشد`)}
          </span> */}
        </>
      )
    } else if (visaType === "Extension for 3 months") {
      return (
        <>
          <div className={"flex justify-start w-full leading-7 indent-4 text-justify"}>
            <>{`خواهشمند است نسبت به  ${data?.visa?.fa_name} با خروج و مراجعت مکرر سه ماهه نامبرده/نامبردگان از تاریخ اتمام پروانه اقامت 3 ماهه`}</>
            <>{`  از طریق مدیریت پلیس مهاجرت و گذرنامه ناجا استان  ${data?.dock?.city?.province?.fa_name} `}</>
            <>{`اوامر مقتضی صادر فرمایید.`}</>
          </div>
          <span className={"leading-7 indent-4 text-justify"}>
            {formatText("ضمنا یادآوری می شود از آنجائیکه نمایندگی شناور ذکر شده به عهده این شرکت می باشد این مدیریت نیز در تمامی موارد به دریانورد/دریانوردان یادشده در برابر اتحادیه و پلیس مهاجرت و گذرنامه ناجا پاسخگو می باشد")}
          </span>
        </>
      )
    }

  }

  const handleDownload = async () => {
    const pdfBlob = await convertToPdf();
    const url = URL.createObjectURL(pdfBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'my-document.pdf';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };



  if (isError)
    return <span className={clsx('text-center text-rose-600 w-full h-72 flex flex-row justify-center bg-white items-center my-container rounded-lg', isPDFMode ? 'fixed -top-[800px]' : '')}>{t('ErrorInLoadingVisa')}</span>

  else if (data) {

    const isReadOnly = !!data?.letter_number

    console.log(ccList)

    return (
      <>
        {/* {loading && <LoadingFix />} */}
        <div className={clsx(`my-container mb-10  ${(activeStep || params?.id || true) ? "h-auto" : "h-0 overflow-hidden "}`, isPDFMode && 'fixed -top-[800px] -z-40 right-[5000px]')}>
          <div className={"text-center my-5 text-2xl font-semibold"}>
            فرم شماره 2
          </div>
          <div ref={contentRef} className={clsx("relative bg-white rounded-lg flex  flex-col items-start gap-5 md:gap-2  px-4 md:px-[4%] mb-8 2xl:mx-[10%]  font-zar", createPdf ? 'py-3 md:py-3' : 'py-5 md:py-10 min-h- [975px]')} >
            {/* Content of the letter */}
            <div className={"flex w-full justify-between flex-row"}>
              <img className={"flex w-[150px] mb-5"} src={formLogo} />
              <div className={"flex flex-col gap-2 pl-4"}>
                <div className={"flex items-center"}>
                  <span className={"pl-2"}>{` شماره نامه :`}</span>
                  {
                    (createPdf || data?.letter_number || defaultLetterNumber) ?
                      <span>{defaultLetterNumber ?? form?.["letter_number"] ?? data?.letter_number}</span>
                      :
                      <input value={form["letter_number"]} onChange={(e) => handleForm({ "name": "letter_number", "value": e.target.value })} className={"border border-1 p-1 mx-1 rounded-md"} />
                  }
                </div>
                <span>
                  <span className={"pl-2"}>{` تاریخ :`}</span>
                  <span>{`${data?.created_at && mode != 'pdf' ? moment(data?.created_at).format('jDD / jMM / jYYYY') : moment(new Date()).format('jDD / jMM / jYYYY')} `}</span>
                </span>
                <span>
                  <span className={"pl-2"}>{` پیوست :`}</span>
                  <span>{`دارد `}</span>
                </span>
              </div>
            </div>

            <div className={"flex justify-between w-full text-lg"} >
              <div className={"flex flex-col gap-2 mx-2"}>
                {!!defaultEmails && defaultEmails?.map(i => i?.title)?.map(item =>
                  <div className='flex flex-col gap-2'>
                    {item.split('/').map(f => <span className={"font-extrabold"}>{f}</span>)}
                  </div>)}
                {!defaultEmails && <>
                  {isReadOnly
                    ? data?.emails?.map(i => i?.title).map(item =>
                      <div className='flex flex-col gap-2'>
                        {item.split('/').map(f => <span className={"font-extrabold"}>{f}</span>)}
                      </div>)
                    :
                    <div className='flex flex-col gap-2'>
                      {emailList?.name?.split('/').map(f => <span className={"font-extrabold"}>{f}</span>)}
                    </div>
                  }</>}

                {/* <span className={"font-extrabold"}>{"آقای یحیی ضیایی مهرجردی "}</span> */}
                {/* <span className={"font-extrabold"}>{"دبیر کل محترم اتحادیه مالکان کشتی ایران"}</span> */}
                <span className={"font-extrabold text-lg"}>{`موضوع : درخواست ${data?.visa?.fa_name}`}</span>
              </div>

            </div>
            <div className={"flex justify-start w-full mt-4"}>
              <span>باسلام</span>
            </div>
            <p className={" justify-start w-full indent-4 text-justify leading-8"}>
              <>{`احتراما, به استحضار می رساند که شرکت سپهر پیام مارین`}</>
              <><p className='inline whitespace-nowrap' dangerouslySetInnerHTML={{ __html: text.topTitle?.[visaType]?.[1] }} />{`  ${data?.ship?.name} با شماره `}</>
              <span className='font-sans font-semibold'>IMO : {data?.ship?.imo}</span>
              <>{` ${text.topTitle?.[visaType]?.[2]} `}</>
              <>{` ${data?.ship?.owner} `}</>
              <>{`اقدام نماید.`}</>
            </p>
            <div className={"w-full py-2"}>
              <table className="w-full border-separate border border-slate-400 ...">
                <thead>
                  <tr className={mode == 'pdf' ? '!text-xs' : "text-sm"}>
                    <th className={`[writing-mode:vertical-lr] font-semibold  text-center bg-gray-200 w-6 py-2 ${createPdf && "!text-[8px]"}`}>{t("row")}</th>
                    <th className={`font-semibold  text-center m-1 bg-gray-200 border border-slate-300 ${createPdf && "!text-[8px]"}`}>{t("nameAndSurname")}</th>
                    <th className={`font-semibold  text-center m-1 bg-gray-200 border border-slate-300 ${createPdf && "!text-[8px]"}`}>{t("floatingName")}</th>
                    <th className={`font-semibold  text-center m-1 bg-gray-200 border border-slate-300 ${createPdf && "!text-[8px]"}`}>{t("post")}</th>
                    <th className={`font-semibold  text-center m-1 bg-gray-200 border border-slate-300 ${createPdf && "!text-[8px]"}`}>{t("nationality")}</th>
                    <th className={`font-semibold  text-center m-1 bg-gray-200 border border-slate-300 ${createPdf && "!text-[8px]"}`}>{t("birth_date")}</th>
                    <th className={`font-semibold  text-center m-1 bg-gray-200 border border-slate-300 ${createPdf && "!text-[8px]"}`}>{t("numberCdc")}</th>
                    <th className={`font-semibold  text-center m-1 bg-gray-200 border border-slate-300 ${createPdf && "!text-[8px]"}`}>{"انقضا CDC"}</th>
                    <th className={`font-semibold  text-center m-1 bg-gray-200 border border-slate-300 ${createPdf && "!text-[8px]"}`}>{t("passportNumber")}</th>
                    <th className={`font-semibold  text-center m-1 bg-gray-200 border border-slate-300 ${createPdf && "!text-[8px]"}`}>{t("passportExpiration")}</th>
                    <th className={`font-semibold  text-center m-1 bg-gray-200 border border-slate-300 ${createPdf && "!text-[8px]"}`}>{t("gender")}</th>
                    {atNumber && <th className={`font-semibold  text-center m-1 bg-gray-200 border border-slate-300 ${createPdf && "!text-[8px]"}`}>{t("automationNumber")}</th>}
                  </tr>
                </thead>
                <tbody>
                  {data?.crews?.map((item, index) => (
                    <tr key={index} className={mode == 'pdf' ? '!text-xs' : ''}>
                      <td className="border border-slate-300 text-center h-14">{index + 1}</td>
                      <td className="border border-slate-300 text-center">{item?.crew?.name + " " + item?.crew?.last_name}</td>
                      <td className="border border-slate-300 text-center">{data?.ship?.name}</td>
                      <td className="border border-slate-300 text-center">{item?.visa_job?.[0]?.name ?? '-'}</td>
                      <td className="border border-slate-300 text-center">{nationalityArray?.find(i => i.Crew_id == item.crew_id)?.NationalityFA ?? '-'}</td>
                      <td className="border border-slate-300 text-center">
                        <span>
                          {item?.crew?.birth_date && moment(item?.crew?.birth_date).format('DD')}
                        </span>
                        <span className={"px-[3px]"}>
                          {" / "}
                        </span>
                        <span>
                          {item?.crew?.birth_date && moment(item?.crew?.birth_date).format('MM')}
                        </span>
                        <span className={"px-[3px]"}>
                          {" / "}
                        </span>
                        <span>
                          {item?.crew?.birth_date && moment(item?.crew?.birth_date).format('YYYY')}
                        </span>
                      </td>
                      <td className="border border-slate-300 text-center">{item?.crew?.cdc_no}</td>
                      <td className="border border-slate-300 text-center">
                        <span>
                          {item?.crew?.cdc_expire && moment(item?.crew?.cdc_expire).format('DD')}
                        </span>
                        <span className={"px-[3px]"}>
                          {" / "}
                        </span>
                        <span>
                          {item?.crew?.cdc_expire && moment(item?.crew?.cdc_expire).format('MM')}
                        </span>
                        <span className={"px-[3px]"}>
                          {" / "}
                        </span>
                        <span>
                          {item?.crew?.cdc_expire && moment(item?.crew?.cdc_expire).format('YYYY')}
                        </span>
                      </td>
                      <td className="border border-slate-300 text-center">{item?.crew?.passport_no}</td>
                      <td className="border border-slate-300 text-center">
                        <span>
                          {item?.crew?.passport_expire && moment(item?.crew?.passport_expire).format('DD')}
                        </span>
                        <span className={"px-[3px]"}>
                          {" / "}
                        </span>
                        <span>
                          {item?.crew?.passport_expire && moment(item?.crew?.passport_expire).format('MM')}
                        </span>
                        <span className={"px-[3px]"}>
                          {" / "}
                        </span>
                        <span>
                          {item?.crew?.passport_expire && moment(item?.crew?.passport_expire).format('YYYY')}
                        </span>
                      </td>
                      <td className="border border-slate-300 text-center">{item?.crew?.gender ? (item?.crew?.gender === 1 ? "مرد" : "زن") : ""}</td>
                      {atNumber && <td className="border border-slate-300 text-center">{atNumber}</td>}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className={"mb -[500px]"} ref={contentRef3} >
              {handleText(data)}
            </div>

            <div ref={contentRef2} className={" justify-end  mt -5 abso lute bott om-5 w-full flex flex-col mx -5 "} >

              <div className={"relative flex flex-col text-center font-bold mr-auto translate-x-1/4 mr- [17%] mt-10 mb-10 "}>
                <span className={"z-40 relative"}>{"با تشکر"}</span>
                <span className={"z-40 relative"}>{"رئیس هیئت مدیره و مدیرعامل"}</span>
                <span className={"z-40 relative mt-2"}>{"عبدالمجید مومنی"}</span>
                <span className={"absolute w-[120px] h-[120px] top- 1 left- [140px]"} style={createPdf ? { left: 20 } : { left: 120 }}>
                  <img className={"flex w-full h-full"} src={emza} alt="Signature" />
                </span>
                <span className={"absolute w-[120px] h-[120px] -top- 10 left -[250px]"}>
                  <img className={"flex w-full h-full"} src={mohr} alt="Mohr" />
                </span>
              </div>
              <div className={"w-[95%] relative flex justify-center self-center -m t-24"}>
                <img className={"w-full"} src={wave} />
              </div>
            </div>

          </div>

          {loading && <div className='flex flex-row justify-center items-center gap-4 text-gray-900 w-full h-72 bg-white rounded'>
            <span>{t('LoadingVisa')}</span>
            <Loading />
          </div>}

          {!loading && !data && <span className='text-center text-rose-600 w-full h-16 flex flex-row justify-center'>{t('ErrorInLoadingVisa')}</span>}

          <div className={`  bg-white p-10 md:py-10 px-4 md:px-[4%] mb-8  2xl:mx-[10%]  rounded-lg`}>
            <strong className={"text-lg mb-7 flex"}>{"خلاصه متن ایمیل "}</strong>

            {
              !isReadOnly ?
                <SunEditor
                  setOptions={{
                    height: 200,
                    buttonList: buttonList.complex
                  }}
                  value={editorData}
                  height="200px"
                  getSunEditorInstance={getSunEditorInstance}
                  defaultValue={data?.email_body}
                  onChange={(e) => setEmailBody(e)}
                />
                :
                <div className={"rtl"} dangerouslySetInnerHTML={{ __html: data?.email_body }} />
            }

          </div>

          <div className={`  bg-white p-10 md:py-10 px-4 md:px-[4%] mb-8  2xl:mx-[10%]  rounded-lg`}>
            <strong className={"text-lg"}>{"ارسال به اداره اتباع / کارگذار"}</strong>
            {
              isReadOnly ?
                data?.emails.map((item) => {
                  return (
                    <div className={"my-5 flex gap-5"}>
                      <div className={"min-w-[150px]"}>
                        <strong>
                          {"عنوان : "}
                        </strong>
                        {emails?.data?.find((emailItem) => {
                          return (
                            emailItem?.id == item?.id
                          )
                        })?.title}
                      </div>
                      {emails?.data?.find((emailItem) => {
                        return (
                          emailItem?.id == item?.id
                        )
                      })?.email}
                    </div>
                  )
                })
                :
                emails?.data?.map((item) => {
                  return (
                    <div className={"my-5 flex gap-5"}>

                      <div className={"min-w-[150px]"}>
                        <strong>
                          {"عنوان : "}
                        </strong>
                        {item?.title}
                      </div>
                      <CustomRadio value={emailList} name={"atba"} label={item.email + " "} id={item.id} onCheck={() => handleEmails({ id: item.id, name: item.title })} />
                    </div>
                  )
                })
            }

          </div>

          <div className={`   bg-white p-10 md:py-10 px-4 md:px-[4%] mb-8  2xl:mx-[10%]  rounded-lg`}>

            <strong className={"text-lg "}>{"رونوشت "}</strong>
            {
              isReadOnly ?
                data?.cc?.map((item) => {
                  return (
                    <div className={"my-5 flex gap-5"}>
                      <div className={"min-w-[150px]"}>
                        <strong>
                          {"عنوان : "}
                        </strong>
                        {emails?.data?.find((emailItem) => {
                          return (
                            emailItem?.email === item
                          )
                        })?.title}
                      </div>
                      {item}
                    </div>
                  )
                })
                :
                emails?.data?.map((item) => {
                  return (
                    <div className={"my-5 flex gap-5"}>
                      <div className={"min-w-[150px]"}>
                        <strong>
                          {"عنوان : "}
                        </strong>
                        {item?.title}
                      </div>
                      <CustomCheckBox label={item.email} id={item.id} onCheck={() => handleCc(item.email)} />
                    </div>
                  )
                })
            }
          </div>


          <div className={`   bg-white p-10 md:py-10 px-4 md:px-[4%] mb-8 flex flex-col gap-2  2xl:mx-[10%]  rounded-lg`}>
            <strong className={"text-lg mb-7 flex"}>{"آپلود فایل "}</strong>

            {
              !isReadOnly ?
                <MultiUploader name={"attachments"} onChange={(e) => {
                  setAttachments(e.value)
                }} />
                :
                <div className={"flex flex-row gap-5 flex-wrap"}>
                  {
                    data?.visa_attachment.map((item) => {


                      return (
                        // <div className={"w-16 h-16 "}>
                        isFileImage(item?.filepath)
                          ? <img className='cursor-pointer border hover:border-primary-300 rounded-lg object-cover aspect-video h-24 w-32 " ' src={"https://api.flysepehr.com/storage" + item?.filepath} onClick={() => window.open("https://api.flysepehr.com/storage" + item?.filepath)} />
                          : <div className='flex flex-col justify-center items-center p-4 cursor-pointer border  text-center rounded-lg hover:border-primary-300 aspect-video h-24 w-32 "' onClick={() => window.open("https://api.flysepehr.com/storage" + item?.filepath)}>
                            <span>{t('ViewWordFile')} </span>
                            {/* <span className='line-clamp-1 text-ellipsis overflow-hidden'>{(item?.filepath?.split('/')).findLast(i=>i)}</span> */}
                          </div>
                        // </div>
                      )
                    })
                  }
                </div>
            }

            {/* {!isReadOnly && <label className='flex flex-col gap-3  p-4  rounded-lg border-dashed border-2 cursor-pointer'>
              <span className='font-bold'>{t('WordFormatOfLetter')}</span>
              <input
                type='file'
                onChange={({ target: { files } }) => {


                  if (files?.[0] instanceof File) {
                    if (files?.[0].name.split('.').toReversed()[0] == 'doc' || files?.[0].name.split('.').toReversed()[0] == 'docx')
                      setWordFile(files?.[0])
                    else
                      return toast.error(t('SelectedFileShouldBeWordFormat'))
                  }

                }}
                accept='.doc,.docx'
              />
            </label>} */}



          </div>

          <div className={"w-full flex justify-center"}>
            {
              !isReadOnly &&
              <div className={"w-[330px] "}>
                <CustomButton loading={loading} disable={loading} onClick={handleSubmit} title={"SendNationalityOffice"} />
              </div>
            }

            {/*<CustomButton onClick={handleDownload} title={"Download PDF"} />*/}


          </div>
        </div>
      </>
    );
  }

  else return <div className={clsx('flex flex-row justify-center items-center gap-4 text-gray-900 w-full h-72 bg-white rounded-lg my-container', isPDFMode && 'fixed -top-[800px] -z-40 right-[5000px]')}>
    <span>{t('LoadingVisa')}</span>
    <Loading />
  </div>
};

export default FormNumberTwo;
